module.exports = __webpack_public_path__ + "static/media/gender.5ff7359f.svg";